<script>
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import AccountModal from "./account-modal.vue";
import LoadingTemplate from "@/components/widgets/loading-template.vue";

export default {
    name: "DisbursementModal",
    props: {
        modalTitle: String,
        banks: Array,
        accounts: Array,
    },
    components: {
        DatePicker,
        MaskedInput,
        AccountModal,
        LoadingTemplate
    },
    data() {
        return {
            form: {
                id: 0,
                particulars: null,
                computations: null,
                jevNumber: null,
                modeOfPayment: '',
                checkNumber: null,
                checkDate: null,
                bank: null,
                accountNumber: null,
                amount: '',
                isRelease: true,
                dateReleased: null,
                receivedBy: null,
                disbursementItems: []
            },
            submitted: false,
            submitAcc: false,
            paymentModes: [
                { value: '', text: "Select Mode of Payment" },
                { value: "Check", text: "Check" },
                { value: "Cash", text: "Cash" },
                { value: "ADA", text: "ADA" },
            ],
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            newAcc: {
                id: 0,
                accountName: "",
                accountId: 0,
                isDebit: true,
                debit: '',
                credit: '',
                accountSearch: '',
                searched: false,
                failedSearch: false,
            },
            amount: 0,
            payeeInfo: null,
            loadPayee: false,
            copyAcc: null,
            selectedItem: null,
            chargingInfo: [],
            loadCharging: false
        };
    },
    validations: {
        form: {
            particulars: { required },
            modeOfPayment: { required },
        },
    },
    computed: {
        balanceOfItems() {
            return this.getTotalDebit() - this.getTotalCredit();
        },
        isEditingAccount(){
            return this.form.disbursementItems.some(item => item.isEdit);
        }
    },
    methods: {
        resetForm() {
            this.form = {
                id: 0,
                particulars: null,
                computations: null,
                jevNumber: null,
                modeOfPayment: 'Cash',
                checkNumber: null,
                checkDate: new Date(),
                bank: '',
                accountNumber: null,
                amount: '',
                isRelease: false,
                dateReleased: new Date(),
                receivedBy: null,
                disbursementItems: []
            };
            this.newAcc = {
                id: 0,
                accountName: "",
                accountId: 0,
                isDebit: true,
                debit: '',
                credit: '',
                accountSearch: '',
                searched: false,
                failedSearch: false,
            }
            this.submitAcc = false;
            this.submitted = false;
            this.$v.form.$reset();
        },
        async getPayeeInfo(id){
            this.payeeInfo = null;
            await this.$store
                .dispatch("supplier/GetSingleSupplier", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.payeeInfo = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async updateData(data) {
            this.form = cloneDeep(data);
            this.form.checkDate = new Date(this.form.checkDate);
            this.form.dateReleased = new Date(this.form.dateReleased);
            this.form.disbursementItems = this.form.disbursementItems.map(item => {
                item.accountName = item.account;
                item.debit = item.isDebit ? item.amount.toString() : '';
                item.credit = !item.isDebit ? item.amount.toString() : '';
                return item;
            });
        },
        async fetchPayeeInfo(id){
            this.loadPayee = true;
            await this.getPayeeInfo(id);
            this.loadPayee = false;
        },
        setPayeeInfo(item){
            if(!item.payee) return;
            this.payeeInfo = {
                name: item.payee,
                address: item.payeeAddress || 'N/A',
                contactNumber: item.contactNumber || 'N/A',
                email: item.email || 'N/A',
                bank: item.bank || 'N/A',
                accountNumber: item.accountNumber || 'N/A',
                tin: item.tin || 'N/A',
            };
        },
        async fetchChargingInfo(item){
            this.chargingInfo = [];
            if(item.accounts && item.accounts.length > 0){
                return this.chargingInfo = item.accounts;
            }
            this.loadCharging = true;
            await this.getChargingInfo(item.id);
            this.loadCharging = false;
        },
        async getChargingInfo(id) {
            await this.$store
                .dispatch("rfppayment/getAllAvailableResource", {deliveryUnitId: id, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.chargingInfo = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        saveDV() {
            if(this.form.disbursementItems.length == 0) return this.submitAcc = true;
            if(this.balanceOfItems != 0) return this.showToast('Disbursement Items must be balanced!', 'error');
            if(this.getTotalDebit() != this.amount) return this.showToast('Total Debit/Credit must be equal to Amount!', 'error');
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) return;
            if(this.form.modeOfPayment === 'Check' && !this.form.bank) return;
            if(this.form.modeOfPayment === 'Check' && !this.form.accountNumber) return;
            let data = cloneDeep(this.form);
            data.checkDate = this.form.checkDate ? this.getDate(this.form.checkDate) : null;
            data.dateReleased = this.form.dateReleased ? this.getDate(this.form.dateReleased) : null;
            data.disbursementItems = data.disbursementItems.map(item => {
                item.debit = this.getExactAmt(item.debit);
                item.credit = this.getExactAmt(item.credit);
                if(item.debit !== ''){
                    item.isDebit = true;
                    item.amount = item.debit;
                }else if(item.credit !== ''){
                    item.isDebit = false;
                    item.amount = item.credit;
                }else{
                    item.isDebit = false;
                    item.amount = 0;
                }
                item.account = item.accountName;
                return item;
            });
            this.$emit("submit", data);
        },
        searchAccount(item){
            if(item){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
            this.$bvModal.show("search-account-modal");
        },
        resetItem() {
            this.newAcc = {
                id: 0,
                accountName: "",
                accountId: 0,
                isDebit: true,
                debit: '',
                credit: '',
            };
        },
        selectAccount(account) {
            if(this.selectedItem){
                this.selectedItem.accountId = account.id;
                this.selectedItem.accountName = account.accountName;
                this.selectedItem.uacs = account.uacs;
            }else{
                this.newAcc.accountId = account.id;
                this.newAcc.accountName = account.accountName;
                this.newAcc.uacs = account.uacs;
                this.newAcc.searched = true;
                this.newAcc.failedSearch = false;
            }
        },
        findAccount(){
            let searchAcc = this.accounts.find(item => item.uacs.replace(/ /g,'') === this.newAcc.accountSearch.replace(/ /g,''));
            if(searchAcc){
                this.newAcc.accountId = searchAcc.id;
                this.newAcc.accountName = searchAcc.accountName;
                this.newAcc.uacs = searchAcc.uacs;
                this.newAcc.searched = true;
                this.newAcc.failedSearch = false;
                this.$refs.accDebit.$el.focus();
            }else{
                this.newAcc.accountId = null;
                this.newAcc.accountName = '';
                this.newAcc.uacs = '';
                this.newAcc.searched = false;
                this.newAcc.failedSearch = true;
            }
        },
        async addToDisbursement(){
            if(this.newAcc.accountId == 0 || this.newAcc.debit === '' && this.newAcc.credit === '') return this.submitAcc = true;
            let dat = cloneDeep(this.newAcc);
            dat.debit = this.getExactAmt(this.newAcc.debit);
            dat.credit = this.getExactAmt(this.newAcc.credit);
            dat.isEdit = false;
            this.form.disbursementItems.push(dat);
            this.resetItem();
            await this.wait(100);
            this.$refs.accountSearch.focus();
            this.submitAcc = false;
        },
        editItem(item) {
            item.isEdit = true;
            this.copyAcc = cloneDeep(item);
        },
        editToDisbursement(item, index){
            if(item.accountId == 0 || item.debit === '' && item.credit === '') return this.submitAcc = true;
            let dat = cloneDeep(item);
            dat.debit = this.getExactAmt(item.debit);
            dat.credit = this.getExactAmt(item.credit);
            dat.isEdit = false;
            this.form.disbursementItems.splice(index, 1, dat);
            this.$refs.accountSearch.focus();
            this.submitAcc = false;
        },
        resetUpdateItem(index) {
            this.form.disbursementItems.splice(index, 1, {...this.copyAcc, isEdit: false});
        },
        deleteItem(index) {
            this.form.disbursementItems.splice(index, 1);
        },
        getTotalDebit() {
            return this.form.disbursementItems.reduce((total, item) => {
                return total + parseFloat(item.debit || 0);
            }, 0);
        },
        getTotalCredit() {
            return this.form.disbursementItems.reduce((total, item) => {
                return total + parseFloat(item.credit || 0);
            }, 0);
        },
    }
};
</script>
<template>
    <b-modal
        id="disbursement-modal"
        :title="modalTitle"
        size="xxl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row">
            <div class="col-md-5">
                <div class="border p-3 position-relative mb-3">
                    <p class="mb-0 position-absolute font-size-22 text-warning" style="top:-16px;left:-4px;">&#8544;.</p>
                    <div class="border-bottom mb-2">
                        <h5 class="text-white">Payee Information</h5>
                    </div>
                    <div class="py-5 d-flex justify-content-center align-items-center" v-if="loadPayee">
                        <LoadingTemplate />
                    </div>
                    <template v-if="!loadPayee && payeeInfo">
                        <div>
                            Payee: <span class="text-white font-weight-bold">{{  payeeInfo.name }}</span>
                        </div>
                        <div>
                            Address: <span class="text-white font-weight-bold">{{  payeeInfo.address }}</span>
                        </div>
                        <div>
                            Contact Number: <span class="text-white font-weight-bold">{{  payeeInfo.contactNumber || 'N/A' }}</span>
                        </div>
                        <div>
                            Email: <span class="text-white font-weight-bold">{{  payeeInfo.email || 'N/A' }}</span>
                        </div>
                        <div>
                            Bank: <span class="text-white font-weight-bold">{{  payeeInfo.bank || 'N/A' }}</span>
                        </div>
                        <div>
                            Bank Account Number: <span class="text-white font-weight-bold">{{  payeeInfo.accountNumber || 'N/A' }}</span>
                        </div>
                        <div>
                            TIN: <span class="text-white font-weight-bold">{{  payeeInfo.tin || 'N/A' }}</span>
                        </div>
                    </template>
                    <template v-if="!loadPayee && !payeeInfo">
                        Cannot view payee information.
                    </template>
                </div>
                <div class="border p-3 position-relative">
                    <p class="mb-0 position-absolute font-size-22 text-warning" style="top:-16px;left:-4px;">&#8545;.</p>
                    <div class="mb-3">
                        <label for="particulars">Particulars</label>
                        <b-form-textarea
                            id="particulars"
                            v-model="form.particulars"
                            placeholder="Enter Particulars..."
                            rows="4"
                            :class="{
                                'is-invalid': submitted && $v.form.particulars.$error,
                            }"
                        ></b-form-textarea>
                        <div
                            v-if="submitted && $v.form.particulars.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.particulars.required">This value is required.</span>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="modeOfPayment">Mode of Payment:</label>
                        <div class="d-flex flex-row">
                            <div 
                                class="d-flex flex-column justify-content-center align-items-center py-2 border rounded-3 me-2 cursor-pointer w-100"
                                :class="{'bg-purple text-white': form.modeOfPayment == 'Cash'}"
                                @click="form.modeOfPayment = 'Cash'"
                            >
                                <i class="bx bx-money font-size-24"></i>
                                Cash
                            </div>
                            <div 
                                class="d-flex flex-column justify-content-center align-items-center py-2 border rounded-3 me-2 cursor-pointer w-100"
                                :class="{'bg-purple text-white': form.modeOfPayment == 'Check'}"
                                @click="form.modeOfPayment = 'Check'"
                            >
                                <i class="bx bx-receipt font-size-24"></i>
                                Check
                            </div>
                            <div 
                                class="d-flex flex-column justify-content-center align-items-center py-2 border rounded-3 me-2 cursor-pointer w-100"
                                :class="{'bg-purple text-white': form.modeOfPayment == 'ADA'}"
                                @click="form.modeOfPayment = 'ADA'"
                            >
                                <i class="bx bx-credit-card font-size-24"></i>
                                ADA
                            </div>
                        </div>
                    </div>
                    <div class="mb-3" v-if="form.modeOfPayment === 'Check'">
                        <label for="modeOfPayment">Select Bank</label>
                        <select 
                            class="form-select" 
                            v-model="form.bank" 
                            :class="{'is-invalid': submitted && !form.bank && form.modeOfPayment === 'Check'}"
                        >
                            <option value="">Select Bank</option>
                            <option v-for="bank in banks" :key="bank.id" :value="bank.accountName">
                                {{ bank.accountName }}
                            </option>
                        </select>
                        <div
                            v-if="submitted && !form.bank && form.modeOfPayment === 'Check'"
                            class="invalid-feedback"
                        >
                            <span>This value is required.</span>
                        </div>
                    </div>
                    <template v-if="form.modeOfPayment === 'Check'">
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="particulars">Check Date</label>
                                <date-picker
                                    id="checkDate"
                                    v-model="form.checkDate"
                                    :first-day-of-week="1"
                                    lang="en"
                                    placeholder="Enter Check Date..."
                                    format="MMMM DD, YYYY"
                                >
                                </date-picker>
                            </div>
                            <div class="col-md-6">
                                <label for="checkNumber">Check Number</label>
                                <b-form-input
                                    id="checkNumber"
                                    v-model="form.checkNumber"
                                    placeholder="Enter Check Number..."
                                ></b-form-input>
                            </div>
                        </div>
                    </template>
                    <div class="mb-3" v-if="form.modeOfPayment === 'Check'">
                        <!-- <div class="col-md-6"> -->
                            <label for="checkNumber">Account Number</label>
                            <b-form-input
                                autocomplete="off"
                                id="accountNumber"
                                v-model="form.accountNumber"
                                placeholder="Enter Account Number..."
                                :class="{ 'is-invalid': submitted && !form.accountNumber && form.modeOfPayment === 'Check' }"
                            ></b-form-input>
                            <div
                                v-if="submitted && !form.accountNumber && form.modeOfPayment === 'Check'"
                                class="invalid-feedback"
                            >
                                <span>This value is required.</span>
                            </div>
                        <!-- </div> -->
                        <!-- <div class="col-md-6">
                            <div>
                                <label for="checkNumber">JEV Number</label>
                                <b-form-input
                                    autocomplete="off"
                                    id="jevNumber"
                                    v-model="form.jevNumber"
                                    placeholder="Enter JEV Number..."
                                ></b-form-input>
                            </div>
                        </div> -->
                    </div>
                    <div class="mb-3">
                        <label for="computations">Notes/Computations</label>
                        <b-form-textarea
                            id="computations"
                            v-model="form.computations"
                            placeholder="Enter Notes/Computations..."
                            rows="4"
                        ></b-form-textarea>
                    </div>
                </div>
            </div>
            <div class="col-md-7">
                <div class="border p-3 position-relative mb-3">
                    <p class="mb-0 position-absolute font-size-22 text-warning" style="top:-16px;left:-4px;">&#8546;.</p>
                    <div class="border-bottom mb-2">
                        <h5 class="text-white">Other Information/Charging of Accounts</h5>
                    </div>
                    <div class="py-5 d-flex justify-content-center align-items-center" v-if="loadCharging">
                        <LoadingTemplate />
                    </div>
                    <template v-if="!loadCharging && chargingInfo.length">
                        <div class="bg-success bg-soft py-2 px-3 rounded">
                            <div v-for="(account, index) in chargingInfo" :key="index">
                                <p class="d-block mb-0">{{account.uacsCode}}</p>
                                <h4 class="mb-0">{{ account.accountName }}</h4>
                                <div class="text-right mt-2">
                                    <h3 class="mb-0 text-warning">{{ formatCurrency(account.amount) }}</h3>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="!loadCharging && !chargingInfo.length">
                        <p class="my-2">No available charging of accounts.</p>
                    </template>
                </div>
                <div class="border p-3 mb-2 position-relative">
                    <p class="mb-0 position-absolute font-size-22 text-warning" style="top:-16px;left:-4px;">&#8547;.</p>
                    <div class="border-bottom mb-2">
                        <h5 class="text-white">Disbursement Items</h5>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p>Total Amount: {{formatCurrency(amount)}}</p>
                        <p class="mb-0 text-green font-size-16">Balance: {{formatCurrency(balanceOfItems)}}</p>
                    </div>
                    <table class="table table-sm align-middle table-bordered border-primary mb-0">
                        <thead>
                            <tr>
                                <th >UACS</th>
                                <th>Account Name</th>
                                <th class="text-center"  style="width:170px;">Debit</th>
                                <th class="text-center"  style="width:170px;">Credit</th>
                                <th class="text-center" style="width:90px;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in form.disbursementItems"
                                :key="index"
                            >
                                <td class="col-md-2" scope="row">
                                    <template v-if="!item.isEdit">{{ item.uacs }}</template>
                                    <template v-else>
                                        <b-form-input
                                            v-model="item.uacs"
                                            placeholder="Enter UACS"
                                        ></b-form-input>
                                    </template>
                                </td>
                                <td class="col-md-4">
                                    <template v-if="!item.isEdit">{{ item.accountName }}</template>
                                    <template v-else>
                                        <b-input-group>
                                            <template #append>
                                                <b-button
                                                    type="button"
                                                    @click="searchAccount(item)"
                                                    variant="outline-info"
                                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                                ></b-button>
                                            </template>
                                            <b-form-input
                                                v-model="item.accountName"
                                                placeholder="Enter Account Name"
                                            ></b-form-input>
                                        </b-input-group>
                                    </template>
                                </td>
                                <td class="text-center">
                                    <template v-if="!item.isEdit">{{item.debit ? formatCurrency(item.debit) : '-'}}</template>
                                    <template v-else>
                                        <form @submit.prevent="editToDisbursement(item, index)">
                                            <masked-input
                                                ref="accDebit"
                                                autocomplete="off"
                                                type="text"
                                                v-model="item.debit"
                                                class="form-control me-1 text-center form-control-sm"
                                                :mask="currencyMask"
                                                :class="{'is-invalid': submitAcc && !item.debit}"
                                            >
                                            </masked-input>
                                        </form>
                                    </template>
                                </td>
                                <td class="text-center">
                                    <template v-if="!item.isEdit">{{item.credit ? formatCurrency(item.credit) : '-'}}</template>
                                    <template v-else>
                                        <form @submit.prevent="editToDisbursement(item, index)">
                                            <masked-input
                                                autocomplete="off"
                                                type="text"
                                                v-model="item.credit"
                                                class="form-control me-1 text-center form-control-sm"
                                                :mask="currencyMask"
                                                :class="{'is-invalid': submitAcc && !item.credit}"
                                            >
                                            </masked-input>
                                        </form>
                                    </template>
                                </td>
                                <td class="text-center col-md-1">
                                    <template v-if="!item.isEdit">
                                        <a href="javascript:void(0)" @click="editItem(item)" v-if="!isEditingAccount">
                                            <i class="bx bx-edit text-success font-size-22 "></i>
                                        </a>
                                        <a href="javascript:void(0)" @click="deleteItem(index)" v-if="!isEditingAccount">
                                            <i class="bx bx-trash text-danger font-size-22 "></i>
                                        </a>
                                    </template>
                                    <template v-if="item.isEdit">
                                        <a href="javascript:void(0)" @click="editToDisbursement(item, index)" >
                                            <i class="bx bx-check me-2 text-green font-size-22 "></i>
                                        </a>
                                        <a href="javascript:void(0)" @click="resetUpdateItem(index)" >
                                            <i class="bx bx-x text-danger font-size-22 "></i>
                                        </a>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <template v-if="!newAcc.accountId">
                                    <td colspan="2">
                                        <form @submit.prevent="findAccount">
                                            <b-input-group>
                                                <template #append>
                                                <b-button
                                                    type="button"
                                                    @click="searchAccount(null)"
                                                    variant="outline-info"
                                                    :disabled="isEditingAccount"
                                                    ><i class="mdi mdi-clipboard-text-search-outline"></i
                                                ></b-button>
                                                </template>
                                                <input 
                                                    ref="accountSearch"
                                                    autocomplete="off"
                                                    type="text" 
                                                    class="form-control" 
                                                    placeholder="Type the UACS or Search Account" 
                                                    v-model="newAcc.accountSearch"
                                                    :disabled="isEditingAccount"
                                                    :class="{'is-invalid': newAcc.accountSearch && newAcc.failedSearch}"
                                                >
                                            </b-input-group>
                                            <span v-if="newAcc.accountSearch && newAcc.failedSearch">
                                                <small class="text-danger" v-if="newAcc.failedSearch">Account not found</small>
                                            </span>
                                        </form>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{newAcc.uacs}}</td>
                                    <td>{{newAcc.accountName}}</td>
                                </template>
                                <td>
                                    <form @submit.prevent="addToDisbursement">
                                        <masked-input
                                            ref="accDebit"
                                            autocomplete="off"
                                            type="text"
                                            v-model="newAcc.debit"
                                            :disabled="isEditingAccount"
                                            class="form-control me-1 text-center form-control-sm"
                                            :mask="currencyMask"
                                            :class="{'is-invalid': submitAcc && !newAcc.debit}"
                                        >
                                        </masked-input>
                                    </form>
                                </td>
                                <td>
                                    <form @submit.prevent="addToDisbursement">
                                        <masked-input
                                            autocomplete="off"
                                            type="text"
                                            v-model="newAcc.credit"
                                            class="form-control me-1 text-center form-control-sm"
                                            :mask="currencyMask"
                                            :disabled="isEditingAccount"
                                            :class="{'is-invalid': submitAcc && !newAcc.credit}"
                                        >
                                        </masked-input>
                                    </form>
                                </td>
                                <td class="text-center">
                                    <template v-if="newAcc.accountId != 0 || newAcc.debit != '' || newAcc.credit != ''">
                                        <a href="javascript:void(0)" @click="addToDisbursement" >
                                            <i class="bx bx-check me-2 text-green font-size-24 "></i>
                                        </a>
                                        <a href="javascript:void(0)" @click="resetItem" >
                                            <i class="bx bx-x text-danger font-size-24 "></i>
                                        </a>
                                    </template>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="text-right">Total:</td>
                                <td class="text-center">{{  formatCurrency(getTotalDebit()) }}</td>
                                <td class="text-center">{{ formatCurrency(getTotalCredit()) }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex gap-1 align-items-center position-relative" :class="{'bg-soft bg-success rounded-3': form.isRelease}">
                    <div
                        class="
                            form-check
                            form-checkbox-outline
                            form-check-success
                            mb-0
                        "
                        :class="{'checkbox-absolute': form.isRelease}"
                    >
                        <input
                            type="checkbox"
                            id="isRelease"
                            class="form-check-input"
                            v-model="form.isRelease"
                        /><label
                            for="isRelease"
                            class="form-check-label"
                        >
                            For Release
                        </label>
                    </div>
                    <template v-if="form.isRelease">
                        <div class="d-flex gap-1 py-3 mt-2 px-4 w-100">
                            <div>
                                <label for="dateReleased" class="mb-0">Date Released</label>
                                <date-picker
                                    id="dateReleased"
                                    v-model="form.dateReleased"
                                    :first-day-of-week="1"
                                    lang="en"
                                    placeholder="Enter Released Date..."
                                    format="MMMM DD, YYYY"
                                >
                                </date-picker>
                            </div>
                            <div class="w-50">
                                <label for="receivedBy" class="mb-0">Received By</label>
                                <b-form-input
                                    id="receivedBy"
                                    autocomplete="off"
                                    v-model="form.receivedBy"
                                    placeholder="Enter Received By..."
                                ></b-form-input>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        
        <div class="modal-footer">
            <button type="button" @click="saveDV" class="btn btn-primary">
                <i class="bx bx-save me-1"></i>{{form.id > 0 ? 'Update' : 'Create'}} Disbursement
            </button>
            <button type="button" class="btn btn-link" @click="$bvModal.hide('disbursement-modal')">
                Close
            </button>
        </div>
        <AccountModal 
            :accounts="accounts"
            @select-account="selectAccount"
        />
    </b-modal>
</template>
<style lang="scss">
.checkbox-absolute{
    position: absolute;
    top: -5px;
    left: 0;
    z-index: 1;
    background: var(--bs-body-bg);
}
</style>